<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<div>
  <h2 mat-dialog-title style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Select Item
    Statement</h2>
  <mat-dialog-content *ngIf="dictionaryItems">
    @if (group) {
      <p-table [value]="dictionaryItems"
               rowGroupMode="subheader"
               dataKey="id">
        >

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
          <tr class="ui-widget-header" *ngIf="rowGroupMetadata[item[group]].index === rowIndex">
            <td colspan="6">
              <a href="#" [pRowToggler]="item">
                <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                <span>{{item[group]}}</span>
              </a>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="expandedrow" let-item>
          <tr>
            <td>
              <span class="cursor-pointer">
                <i [ngClass]="item.show ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'" (click)="item.show = !item.show"></i>
              </span>
              {{ item.name }}
            </td>
            <td style="width: 10em;">
            </td>
          </tr>
          @if(item.show) {
            <tr (click)="selectImplementationControlStatement(item)">
              <td>
                <div [innerHTML]="item.details"></div>
              </td>
            </tr>
          }
        </ng-template>
      </p-table>
    } @else {
      <p-table [value]="dictionaryItems"
               rowGroupMode="subheader"
               dataKey="id">
        >
        <ng-template pTemplate="body" let-set>
          <tr (click)="selectImplementationControlStatement(set)">
            <td>{{ set.name }}</td>
            <td style="width: 10em;">
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  </mat-dialog-content>
</div>
